import {ELEMENT} from '../incase-domain/elements/base/ElementTypes';

export const INCASE_ELEMENT_MIME = 'application/x-incase-element';

export type ElementDragPayload = {
    type: ELEMENT;
    elementProps?: Record<string, unknown>;
};

export type ElementPlacement = {
    xPosition: number;
    yPosition: number;
};

export function clientPointToSlidePercent(clientX: number, clientY: number, slideRect: DOMRect): ElementPlacement {
    const width = slideRect.width || 1;
    const height = slideRect.height || 1;
    const xPosition = ((clientX - slideRect.left) / width) * 100;
    const yPosition = ((clientY - slideRect.top) / height) * 100;

    return {
        xPosition: Math.min(100, Math.max(0, xPosition)),
        yPosition: Math.min(100, Math.max(0, yPosition)),
    };
}

export function setElementDragPayload(dataTransfer: DataTransfer, payload: ElementDragPayload): void {
    const transfer = dataTransfer;
    transfer.effectAllowed = 'copy';
    transfer.setData(INCASE_ELEMENT_MIME, JSON.stringify(payload));
}

export function parseElementDragPayload(dataTransfer: DataTransfer): ElementDragPayload | null {
    const raw = dataTransfer.getData(INCASE_ELEMENT_MIME);
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw) as ElementDragPayload;
        if (!parsed?.type) return null;
        return parsed;
    } catch {
        return null;
    }
}

export function hasElementDragPayload(dataTransfer: DataTransfer): boolean {
    return Array.from(dataTransfer.types).includes(INCASE_ELEMENT_MIME);
}
